import { loan_application } from '@axo/shared/data-access/types';
import { Broker } from '@axo/shared/data-access/types/broker';

export const TRUSTPILOT_LINK =
  'https://widget.trustpilot.com/trustbox-data/539adbd6dec7e10e686debee?businessUnitId=548ebd7e00006400057c2904&locale=sv-SE&reviewStars=4%2C5&reviewsPerPage=1';

export const INTEREST_RATE = 0.0695;
export const STARTUP_FEE = 495;
export const MONTHLY_FEE = 0;
export const RATES = {
  LOW: 7.9,
  MID: 12,
  HIGH: 16,
};
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const DEFAULT_LOAN_AMOUNT = 500_000;
export const DEFAULT_LOAN_DURATION = 15;
export const MAX_LOAN_DURATION = 15;
export const MIN_LOAN_AMOUNT = 5_000;
export const MAX_LOAN_AMOUNT = 800_000;

export const PHONE_REGEX = /(07[02369])(\d{7})/;

type OptionList<T> = { value: T; text: string }[];

export const radioOptions = [
  { text: 'yes', value: 'Yes' },
  { text: 'no', value: 'No' },
];

export const initialPurposeOptions: OptionList<loan_application.Purpose> = [
  { text: 'yes', value: loan_application.Purpose.RefinancingLoan },
  { text: 'no', value: loan_application.Purpose.Other },
];

const axoPurposeOptions: OptionList<loan_application.Purpose> = [
  {
    value: loan_application.Purpose.Vehicle,
    text: 'Purpose.Vehicle',
  },
  { value: loan_application.Purpose.Renovation, text: 'Purpose.Renovation' },
  { value: loan_application.Purpose.Other, text: 'Purpose.Other' },
  { value: loan_application.Purpose.Holiday, text: 'Purpose.Holiday' },
  { value: loan_application.Purpose.Medical, text: 'Purpose.Medical' },
];
const zmartaPurposeOptions: OptionList<loan_application.Purpose> = [
  {
    value: loan_application.Purpose.Vehicle,
    text: 'Purpose.Vehicle',
  },
  {
    value: loan_application.Purpose.PropertyDivision,
    text: 'Purpose.PropertyDivision',
  },
  {
    value: loan_application.Purpose.HomeInteriorDesign,
    text: 'Purpose.HomeInteriorDesign',
  },
  { value: loan_application.Purpose.Renovation, text: 'Purpose.Renovation' },
  {
    value: loan_application.Purpose.EstateInventory,
    text: 'Purpose.EstateInventory',
  },
  { value: loan_application.Purpose.Wedding, text: 'Purpose.Wedding' },
  {
    value: loan_application.Purpose.DebtCollection,
    text: 'Purpose.DebtCollection',
  },
  {
    value: loan_application.Purpose.Investment,
    text: 'Purpose.Investment',
  },
  {
    value: loan_application.Purpose.InvestmentOwnCompany,
    text: 'Purpose.InvestmentOwnCompany',
  },
  { value: loan_application.Purpose.Consumption, text: 'Purpose.Consumption' },
  {
    value: loan_application.Purpose.DrivingLicense,
    text: 'Purpose.DrivingLicense',
  },
  { value: loan_application.Purpose.Medical, text: 'Purpose.Medical' },
  { value: loan_application.Purpose.Holiday, text: 'Purpose.Holiday' },
  { value: loan_application.Purpose.Studies, text: 'Purpose.Studies' },
  { value: loan_application.Purpose.Dentist, text: 'Purpose.Dentist' },
];

export const purposeOptions = {
  [Broker.Axo]: axoPurposeOptions,
  [Broker.Zmarta]: zmartaPurposeOptions,
} as const;

export const childOptions: OptionList<string> = [
  { value: '0', text: '0 barn' },
  { value: '1', text: '1 barn' },
  { value: '2', text: '2 barn' },
  { value: '3', text: '3 barn' },
  { value: '4', text: '4 barn' },
  { value: '5', text: '5 eller fler' },
];

export const housingOptions: OptionList<loan_application.Residence> = [
  { value: loan_application.Residence.OwnHouse, text: 'HousingType.OwnHouse' },
  {
    value: loan_application.Residence.CooperativeApartment,
    text: 'HousingType.CooperativeApartment',
  },
  { value: loan_application.Residence.Tenant, text: 'HousingType.Tenant' },
  { value: loan_application.Residence.Rental, text: 'HousingType.Rental' },
];

const axoMaritalStatusOptions: OptionList<loan_application.MaritalStatus> = [
  {
    value: loan_application.MaritalStatus.Married,
    text: 'MaritalStatus.Married',
  },
  {
    value: loan_application.MaritalStatus.Cohabiting,
    text: 'MaritalStatus.Cohabiting',
  },
  {
    value: loan_application.MaritalStatus.Single,
    text: 'MaritalStatus.Single',
  },
];
const zmartaMaritalStatusOptions: OptionList<loan_application.MaritalStatus> = [
  {
    value: loan_application.MaritalStatus.Single,
    text: 'MaritalStatus.Single',
  },
  {
    value: loan_application.MaritalStatus.Married,
    text: 'MaritalStatus.Married',
  },
  {
    value: loan_application.MaritalStatus.Cohabiting,
    text: 'MaritalStatus.Cohabiting',
  },
  {
    value: loan_application.MaritalStatus.Seperated,
    text: 'MaritalStatus.Seperated',
  },
  {
    value: loan_application.MaritalStatus.Widowed,
    text: 'MaritalStatus.Widowed',
  },
];

export const maritalStatusOptions = {
  [Broker.Axo]: axoMaritalStatusOptions,
  [Broker.Zmarta]: zmartaMaritalStatusOptions,
};

const axoEmploymentOptions: OptionList<loan_application.EmploymentStatus> = [
  {
    value: loan_application.EmploymentStatus.Permanent,
    text: 'EmploymentStatus.Permanent',
  },
  {
    value: loan_application.EmploymentStatus.Temporary,
    text: 'EmploymentStatus.Temporary',
  },
  {
    value: loan_application.EmploymentStatus.Entrepreneur,
    text: 'EmploymentStatus.Entrepreneur',
  },
  {
    value: loan_application.EmploymentStatus.Pensioner,
    text: 'EmploymentStatus.Pensioner',
  },
  {
    value: loan_application.EmploymentStatus.Student,
    text: 'EmploymentStatus.Student',
  },
  {
    value: loan_application.EmploymentStatus.EarlyRetirement,
    text: 'EmploymentStatus.EarlyRetirement',
  },
  {
    value: loan_application.EmploymentStatus.Unemployed,
    text: 'EmploymentStatus.Unemployed',
  },
];

const zmartaEmploymentOptions: OptionList<loan_application.EmploymentStatus> = [
  {
    value: loan_application.EmploymentStatus.Permanent,
    text: 'EmploymentStatus.Permanent',
  },
  {
    value: loan_application.EmploymentStatus.Entrepreneur,
    text: 'EmploymentStatus.Entrepreneur',
  },
  {
    value: loan_application.EmploymentStatus.Temporary,
    text: 'EmploymentStatus.Temporary',
  },
  {
    value: loan_application.EmploymentStatus.Hourly,
    text: 'EmploymentStatus.Hourly',
  },
  {
    value: loan_application.EmploymentStatus.Project,
    text: 'EmploymentStatus.Project',
  },
  {
    value: loan_application.EmploymentStatus.Pensioner,
    text: 'EmploymentStatus.Pensioner',
  },
  {
    value: loan_application.EmploymentStatus.Unemployed,
    text: 'EmploymentStatus.Unemployed',
  },
  {
    value: loan_application.EmploymentStatus.Student,
    text: 'EmploymentStatus.Student',
  },
  {
    value: loan_application.EmploymentStatus.Probationary,
    text: 'EmploymentStatus.Probationary',
  },
  {
    value: loan_application.EmploymentStatus.SickPensioner,
    text: 'EmploymentStatus.SickPensioner',
  },
];

export const employmentOptions = {
  [Broker.Axo]: axoEmploymentOptions,
  [Broker.Zmarta]: zmartaEmploymentOptions,
} as const;

export const grossIncomeMonthlyMinimum = {
  [Broker.Axo]: 9_200,
  [Broker.Zmarta]: 8_333,
} as const;
